import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './Button.module.scss';

export const Button = ({
  id,
  className,
  type = 'primary',
  submit = false,
  small = false,
  style = null,
  icon,
  onlyIcon = false,
  prependIcon = true,
  disabled = false,
  children,
  buttonProps = {},
  tip,
  placement = 'bottom',
  edged = false,
  square = false,
  dataTestId,
  onClick = () => {},
}) => (
  <OverlayTrigger
    trigger={tip === undefined ? 'none' : ['hover', 'focus']}
    placement={placement}
    overlay={<Tooltip>{tip}</Tooltip>}>
    <button
      id={id}
      className={cn(styles.root, styles[`root--${type}`], {
        [styles['root--small']]: small,
        [className]: className,
        [styles.edged]: edged,
        [styles.prependIconPadding]: prependIcon,
        [styles.appendIconPadding]: !prependIcon,
        [styles.square]: square,
      })}
      type={submit ? 'submit' : 'button'}
      disabled={disabled}
      onClick={onClick}
      style={style}
      data-testid={dataTestId}
      {...buttonProps}>
      {prependIcon && (
        <FeatherIcon className={cn(styles.icon, { [styles.onlyIcon]: onlyIcon })} icon={icon} />
      )}
      {children}
      {!prependIcon && (
        <FeatherIcon
          className={cn(styles.appendIcon, { [styles.onlyIcon]: onlyIcon })}
          icon={icon}
        />
      )}
    </button>
  </OverlayTrigger>
);

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf([
    'primary',
    'outline',
    'secondary',
    'secondary-reverse',
    'link',
    'success',
    'delete',
    'warn',
  ]),
  small: PropTypes.bool,
  style: PropTypes.object,
  icon: PropTypes.string,
  submit: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.any,
  buttonProps: PropTypes.object,
};
